<template>
  <div id="aboutUsHs">
    <div class="kt-banner">
      <label class="love">为爱设计</label><br/>
      <label class="loveUs">Design for love</label>
    </div>
    <div class="box">
      <p class="gs-title">公司简介<br/><label>Company profile</label></p>
      <i class="zp1"></i><i class="zp2"></i>
      <p class="gs-cent">糖糖圈是一个由中国慈展会认证，世界糖尿病基金会（WDF）资助，中国联合健康产业集团投资，中华医学会糖尿病分会1型学组、广东省糖尿病防治中心、广东省精准医学学会支持下成立的社会企业。</p>
      <p class="gs-cent">团队以解决中国1型糖尿病患者长期存活者少、血糖控制差、并发症多、经济负担重、教育机会少等社会问题为首要目标，通过移动互联网技术、可穿戴医疗设备、结合台湾糖尿病患教模式创新性的解决中国1型糖尿病管理现状的难题。</p>
      <p class="gs-cent">我们不仅针对1型糖尿病患者提供专业化患者教育、家庭教育、心理支持、血糖管理服务，而且努力在让1型糖尿病患者能够愉快、便捷的正常生活，免受疾病及并发症的干扰。</p>
      <br/>
      <br/>
      <p class="gs-cent">1型糖尿病是一个终身性疾病，生活起来并不容易。需要患者与家属能够熟练掌握疾病知识，成为自己的医生，才能更好的享受生活。</p>
      <p class="gs-cent">为此，我们提供每周7天、每天24小时的应急响应支持，帮助患者及家属解决疾病带来的困难。</p>
      <p class="gs-cent">糖糖圈是中国1型糖尿病登记管理项目与中国1型糖尿病教育管理项目的参与者之一，欢迎您加入我们并在糖糖圈建档跟踪。我们将会有专业的患教师与您长期保持沟通。</p>
      <p class="gs-cent">通过我们远程教育跟踪以及同伴互助的方式，在糖糖圈的长期用户中，小于18岁患者的糖化血红蛋白达标率高达82.73%（A1C≤7.5%），大于18岁患者的糖化血红蛋白达标率高达88.82%（A1C≤7.5%），这无论是在国内还是国际上，都是极其好的结果。</p>
      <br/>
      <br/>
      <p style="font-size: 18px;color: #000;font-weight: bold" class="gs-cent">社会责任</p>
      <p class="gs-cent">1.我们将致力于为儿童、青少年糖尿病患者及家庭提供支援；</p>
      <p class="gs-cent">2.凝聚社会力量以争取年轻患者在求学、求职中的合法权益；</p>
      <p class="gs-cent">3.推动、完善、建立1型糖尿病社会救助保障制度；</p>
      <p class="gs-cent">4.提升大众对1型糖尿病的理解，宣传治疗糖尿病的科学治疗方法。</p>
      <br/>
      <br/>
      <p style="font-size: 18px;color: #000;font-weight: bold" class="gs-cent">科学研究</p>
      <p class="gs-cent">中国1型糖尿病登记管理项目</p>
      <p class="gs-cent">中国1型糖尿病教育管理项目</p>
      <p class="gs-cent">中国1型糖尿病合并妊娠结局研究项目</p>
      <p class="gs-cent">广东省1型糖尿病转化医学研究项目</p>
      <p class="gs-cent">广东省级科技项目：1型糖尿病病教育课程开发及科普平台建设</p>
      <p class="gs-cent">广东省级科技项目：1型糖尿病餐后血糖预测模型研究项目</p>
    </div>
    <section class="contact">
      <p>400热线：400-836-5596</p>
      <p>客服电话：0755-27299992</p>
      <p>渠道合作：caoqifan@ttq.so</p>
      <p>微信客服：ttqcare</p>
      <p>地址：广东省深圳市宝安西乡街道宝民二路IDT研发中心4层</p>
    </section>
    <section class="hs-box-s">
      <p class="hs-logo2"></p>
      <p class="hs-end">
        爱宝惟生物科技有限公司版权所有
        <span style="font-size: 14px;margin-top: 15px">Copyright @ 2014-2024 aibaowei.All Rights Reserved<br/><a href="http://www.beian.miit.gov.cn">粤ICP备14072944号</a></span>
      </p>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'aboutUsHs',
    data () {
      return {

      }
    },
    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .kt-banner{background: url("../../site/welcomeHs.png") no-repeat center center;height: 290px;width: 100%;margin-top: 150px;}
  .box{width: 100%;margin: 0 auto;text-align: center;padding:60px 0;}
  .zp1{width: 536px;height: 375px;background: url("../../site/zp1.jpg")}
  .zp2{width: 536px;height: 375px;background: url("../../site/zp2.jpg");}
  .gs-cent{color: #333;font-size: 16px;text-align: left;text-indent: 2em;width: 80%;margin: 15px auto 0 auto;line-height: 30px}
  .gs-title{color: #333;font-size: 48px;text-align: center;border-bottom: 1px solid #d9d9d9;width: 90%;margin: 0 auto 40px auto;padding-bottom: 40px}
  .gs-title label{color: #999;font-size: 20px;position: relative;top:-20px;left:-5px;letter-spacing: 0}
  .hs-logo2{background: url("../../site/logo.png") no-repeat center;height: 98px;margin-bottom: 35px;background-size: auto 100%}
  .hs-end{font-size: 20px;color: #999;line-height: 20px}
  .hs-box-s{text-align: center;background: #f7f8fa;padding: 80px 0}
  .contact{font-size: 18px;color: #313030;width: 90%;margin: 0 auto;border-top: 1px solid #d9d9d9;padding: 50px 10px;line-height: 30px}
  .love{text-shadow:#bdc6cc 2px 2px 2px;color: #fff;font-size: 58px;margin:  77px 0 0 32px;}
  .loveUs{text-shadow:#bdc6cc 2px 2px 2px;color: #fff;font-size: 24px;position: relative;top: 0;left: 32px;letter-spacing: 3px}
</style>



// WEBPACK FOOTER //
// aboutUsHs.vue?f3b926fe